import { TagGroupAutoColumnGq } from './TagGroupAutoColumnGq';
import { TagGq, TagGqProps } from './TagGq';
import { TagGenerationRequestGq, TagGenerationRequestGqProps } from './TagGenerationRequestGq';

export interface TagGroupGq {
  id: number;
  name: string;
  hasName: boolean;
  projectId: number;
  tags: TagGq[];
  autotagQueued?: string;
  inContentPlan: boolean;
  contentPlanOrder?: number;
  autotagColumn?: TagGroupAutoColumnGq;
  generated: boolean;
  tagGenerationRequest?: TagGenerationRequestGq;
}

export const TagGroupGqProps = `
  id
  name
  hasName
  projectId
  tags { ${TagGqProps} }
  autotagQueued
  inContentPlan
  contentPlanOrder
  autotagColumn
  generated
  tagGenerationRequest { ${TagGenerationRequestGqProps} }
`;
